/* Nordic About Us — mobile swipe slider dots (scroll-snap does the sliding). */
if (!customElements.get('na-slider')) {
  customElements.define(
    'na-slider',
    class NaSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-na-track]');
        this.dots = Array.from(this.querySelectorAll('.na-dots__dot'));
        if (!this.track || !this.dots.length) return;
        this.onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index))));
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      }

      slides() {
        return Array.from(this.track.children);
      }

      onScroll() {
        window.cancelAnimationFrame(this.raf);
        this.raf = window.requestAnimationFrame(() => {
          const slides = this.slides();
          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          let index = 0;
          if (this.track.scrollLeft >= maxScroll - 4) {
            index = slides.length - 1;
          } else {
            const left = this.track.getBoundingClientRect().left;
            let best = Infinity;
            slides.forEach((slide, i) => {
              const d = Math.abs(slide.getBoundingClientRect().left - left);
              if (d < best) {
                best = d;
                index = i;
              }
            });
          }
          this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        });
      }

      goTo(index) {
        const slide = this.slides()[index];
        if (!slide) return;
        this.track.scrollTo({ left: slide.offsetLeft - this.track.firstElementChild.offsetLeft, behavior: 'smooth' });
      }
    }
  );
}
